const isRetinaScreen =
  typeof window !== 'undefined' ? window.devicePixelRatio > 1 : false;

export default isRetinaScreen;
